import { Cookies } from 'react-cookie'
import humps from 'humps'

import { name } from './constants'

import { navigate } from '@reach/router'
import { BE_API_KEY_HEADER } from '_/services/requests'

export const getToken = (config = false) => {
  const cookies = new Cookies()
  const token = cookies.get(name, { path: '/' })

  if (config) {
    return { headers: { Authorization: `Bearer ${token}`, ...BE_API_KEY_HEADER, ...config } }
  }

  return { headers: { Authorization: `Bearer ${token}`, ...BE_API_KEY_HEADER } }
}

export const removeToken = () => {
  const cookies = new Cookies()

  if (process.env.NODE_ENV === 'development') {
    cookies.remove('authTokenrefera', { path: '/' })
  } else {
    cookies.remove('authToken', { path: '/' })
  }
  navigate('/login')
}

export const camelize = data => {
  const camelized = []

  if (data) {
    if (data.length > 0) {
      data.map(obj => camelized.push(humps.camelizeKeys(obj)))
      return camelized
    }

    if (typeof data === 'object') {
      return humps.camelizeKeys(data)
    }

    return humps.camelize(data)
  }

  return false
}
